import { CalculationApi } from "../api/CalculationApi";
import { QuoteApi } from "../api/QuoteApi";
import { QuotingType } from "../state/quote-reducer";
import { QuoteMetadata } from "./types/QuoteMetadata";

export class BaseQuoteHandler<QuoteDetail> {
  async loadBase(id: number): Promise<{ response: any }> {
    const result = await QuoteApi.getQuoteById(id);
    const resultData = result.data;

    return {
      response: resultData,
    };
  }

  async calculateBase(quote: QuotingType): Promise<QuoteDetail> {
    const result = await CalculationApi.getCalculation(quote);
    const resultData: QuoteDetail = result.data;

    return resultData;
  }

  async saveBase(quoteToSave: QuoteDetail): Promise<number> {
    const result = await QuoteApi.createQuote(quoteToSave);

    return result.data;
  }

  async copyBase(quoteToCopy: QuoteDetail): Promise<number> {
    const result = await QuoteApi.createQuote(quoteToCopy);

    return result.data;
  }

  async updateBase(
    id: number,
    quoteToUpdate: QuoteDetail
  ): Promise<QuoteDetail> {
    const result = await QuoteApi.updateQuote(id, quoteToUpdate);

    return result.data;
  }

  async submitBase(quoteToSubmit: QuoteDetail): Promise<boolean> {
    const result = await QuoteApi.submitQuoteToSalesforce(quoteToSubmit);

    return result.data.successful;
  }

  async submitForReviewBase(quoteToSubmit: QuoteDetail): Promise<boolean> {
    const result = await QuoteApi.submitQuoteForReview(quoteToSubmit);

    return result.data.successful;
  }

  async submitExceptionBase(
    id: number,
    status: string | undefined
  ): Promise<void> {
    const result = await QuoteApi.submitQuoteExceptions(id, status);

    return result.data.successful;
  }

  public getMetadataFromQuote(metadata: any): QuoteMetadata {
    return {
      createdDate: metadata.created_on,
      updatedDate: metadata.updated_at,
      valid: metadata.valid,
      pricingLastUpdated: metadata.pricingLastUpdated,
      submittedToSalesforce: metadata.submittedToSalesforce ?? false,
      underwriterStatus: metadata.underwriterStatus,
      exceptionStatus: metadata.exceptionStatus,
      rateLock: metadata.rateLock ?? {},
      ownerRole: metadata.ownerRole,
      ownerBalance: metadata.ownerBalance,
      milestone: metadata.milestone,
      milestoneUpdatedAt: metadata.milestoneUpdatedAt,
    };
  }
}
